/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBiohazard = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M12 9c-.986 0-1.861.476-2.408 1.21a4 4 0 0 1 .274-6.478L8.76 2.066a6.003 6.003 0 0 0-1.927 7.937A6 6 0 0 0 1.12 17.2l1.96-.398a4 4 0 0 1 5.973-4.235 3.005 3.005 0 0 0 1.748 2.185A4 4 0 0 1 6.2 19.92l-.4 1.96a5.994 5.994 0 0 0 6.2-2.562 5.994 5.994 0 0 0 6.199 2.562l-.398-1.96a4 4 0 0 1-4.601-5.17 3.005 3.005 0 0 0 1.748-2.185 4 4 0 0 1 5.973 4.235l1.96.398a6 6 0 0 0-5.575-7.191 6.003 6.003 0 0 0-1.924-7.943l-1.105 1.668a4 4 0 0 1 .182 6.548A2.996 2.996 0 0 0 12 9zm0 2a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
        <path d="M17 14a2 2 0 0 1-2 2v2a4 4 0 0 0 4-4zM7 14a2 2 0 0 0 2 2v2a4 4 0 0 1-4-4zm3.707-6.172a2 2 0 0 1 2.828 0l1.415-1.414a4 4 0 0 0-5.657 0z" />
      </g>
    </g>
  </Icon>
);
export { SvgBiohazard as Biohazard };
